export default function WhatsAppWidget() {
  const phoneNumber = '917774926163';
  const message = encodeURIComponent('Hi, I am interested in Anuruchi Masale products. Please share more details.');
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-widget"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-[9999] w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300 group"
    >
      <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white">
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958A15.914 15.914 0 0016.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.302 22.602c-.39 1.1-1.932 2.014-3.178 2.28-.852.18-1.964.324-5.71-1.228-4.798-1.986-7.882-6.85-8.12-7.168-.23-.318-1.882-2.508-1.882-4.784s1.19-3.396 1.614-3.862c.39-.428.85-.536 1.134-.536.282 0 .566.002.814.016.262.014.614-.1.96.732.356.854 1.21 2.952 1.318 3.168.108.218.18.47.036.756-.144.29-.216.47-.432.722-.216.254-.454.566-.648.76-.216.214-.44.448-.19.878.252.428 1.12 1.846 2.404 2.992 1.652 1.476 3.044 1.934 3.474 2.15.43.216.68.18.93-.108.252-.29 1.082-1.26 1.37-1.692.288-.43.576-.358.97-.214.394.144 2.496 1.178 2.924 1.392.428.216.714.324.822.502.106.178.106 1.032-.284 2.13z" />
      </svg>
      <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#C0392B] rounded-full border-2 border-white animate-pulse" />
    </a>
  );
}
